import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Choose.css';

const ChooseRightDetails = ({data}) => {
    const {id, title,icon, description} =data;
    return (
       
            <div className="textRight leftRight animate__animated animate__fadeInRight animate__delay-2s">
             <div className="icons-right mt-2">
             <FontAwesomeIcon icon={icon} />
             </div>
            <h4 className="titleRight mt-3">{title}</h4>
            <p>{description}</p>
        
       </div>
    );
};

export default ChooseRightDetails;